import React from 'react';
import { SvgIcon } from '@mui/material';

export function YandexLogo(props) {
  return (
    <SvgIcon
      sx={{ width: '200px', height: '64px', viewBox: '0 0 200px 64px' }}
      {...props}
      viewBox="0 0 200 64"
      fill="none"
    >
      <svg
        width="200"
        height="64"
        viewBox="0 0 200 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M171.443 50.1588C174.508 50.1588 176.679 49.6093 178.297 48.4256V43.0567C176.637 44.1981 174.636 44.9168 171.826 44.9168C167.1 44.9168 165.142 41.2812 165.142 35.5319C165.142 29.4867 167.526 26.4006 171.869 26.4006C174.423 26.4006 176.935 27.2884 178.255 28.1339V22.5537C176.85 21.7927 174.423 21.2432 171.102 21.2432C162.63 21.2432 158.245 27.2884 158.245 35.7433C158.287 45.0014 162.587 50.1588 171.443 50.1588ZM130.018 47.7069V42.3381C127.975 43.7331 124.483 44.9591 121.29 44.9591C116.437 44.9591 114.606 42.6763 114.308 38.0261H130.316V34.5596C130.316 24.8788 126.016 21.2432 119.417 21.2432C111.328 21.2432 107.496 27.3729 107.496 35.7855C107.496 45.4664 112.307 50.1588 120.737 50.1588C124.952 50.1588 128.06 49.0174 130.018 47.7069ZM69.2646 21.7505V32.7418H60.4092V21.7505H53.7676V49.6093H60.4092V37.9838H69.2646V49.6093H75.9062V21.7505H69.2646ZM105.836 44.3672H102.898V21.7505H83.5696V24.1178C83.5696 30.924 83.1438 39.7171 80.8022 44.3672H78.6735V55.9504H84.8042V49.6093H99.6626V55.9504H105.793V44.3672H105.836ZM151.177 49.6093H158.713L148.07 34.6019L157.436 21.7505H150.752L141.385 34.6019V21.7505H134.744V49.6093H141.385V35.9124L151.177 49.6093ZM119.247 26.4006C122.525 26.4006 123.547 29.1062 123.547 32.615V33.1645H114.308C114.478 28.7257 116.096 26.4006 119.247 26.4006ZM96.2567 44.3672H86.8904C88.7211 40.1821 89.2319 32.5727 89.2319 27.7534V26.9079H96.2567V44.3672Z"
          fill="black"
        />
        <path
          d="M48.3531 49.64H41.523V16.8953H38.473C32.8887 16.8953 29.9676 19.5997 29.9676 23.6356C29.9676 28.2124 31.9866 30.3344 36.1534 33.0388L39.5899 35.2856L29.7099 49.64H22.3643L31.2563 36.8251C26.1444 33.2885 23.2663 29.8351 23.2663 24.0101C23.2663 16.7288 28.5071 11.7776 38.4301 11.7776H48.3101V49.64H48.3531Z"
          fill="#ED1D1D"
        />
      </svg>
    </SvgIcon>
  );
}
